import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VRow, [_c(VCol, [_c(VSelect, {
    attrs: {
      "multiple": "",
      "items": _vm.toolboxActions,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.toolbox.actions.label')
    },
    model: {
      value: _vm.activeToolboxActions,
      callback: function ($$v) {
        _vm.activeToolboxActions = $$v;
      },
      expression: "activeToolboxActions"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };